import CatRootModulePropertiesPane from '../_CAT_ROOT_MODULE/CatRootModulePropertiesPane.jsx'

export default function PropertiesPaneCatRootOm(props) {
    return (
        <CatRootModulePropertiesPane
            {...props}
        />
    )
}
